export const colors = [
  // "rgba(180, 120, 255, 0.5)", // Brighter lavender
  // "rgba(135, 227, 255, 0.5)", // Brighter sky blue
  // "rgba(255, 140, 100, 0.5)", // Brighter orange-red
  // "rgba(134, 255, 225, 0.5)", // Brighter mint green
  // "rgba(193, 203, 255, 0.5)", // Brighter periwinkle
  // "rgba(255, 130, 130, 0.5)", // Brighter red
  // "rgba(58, 202, 58, 0.5)", // Brighter lime green
  // "rgba(255, 110, 80, 0.5)", // Brighter coral
  // "rgba(50, 200, 255, 0.5)", // Brighter electric blue
  // "rgba(240, 120, 255, 0.5)", // Brighter purple

  {back: "#FFA726", color: "white"},
  {back: "#59FFAC", color: "black"},
  {back: "#FF7043", color: "white"},
  {back: "#69C303", color: "white"},
  {back: "#FF00F2", color: "white"},
  {back: "#FFF176", color: "black"},
  {back: "#A774FF", color: "white"},
  {back: "#00F0FF", color: "black"},
  {back: "#2196F3", color: "white"},
  {back: "#FF79B2", color: "white"},
];

// export const xScale = 1.5;
export const screenWidth = window.innerWidth;
export const screenHeight = window.innerHeight;
export const xScale = screenHeight / 750;

export interface ICircleRadiusItem {
  radius: number;
  color: string;
  thick?: number;
}
export interface ISizeCircleRadius {
  fiveCircleRadius: ICircleRadiusItem;
  fourthCircleRadius: ICircleRadiusItem;
  thirdCircleRadius: ICircleRadiusItem;
  secondCircleRadius: ICircleRadiusItem;
  firstCircleRadius: ICircleRadiusItem;
  logoRadius: ICircleRadiusItem;
}

export interface ISizeCircleRadiusWS {
  thirdCircleRadius: ICircleRadiusItem;
  secondCircleRadius: ICircleRadiusItem;
  firstCircleRadius: ICircleRadiusItem;
}

export const sizeCircleRadius: ISizeCircleRadius = {
  fiveCircleRadius: {
    radius: 360 * xScale,
    color: "rgba(17, 160, 218, 0.3)",
    thick: 1,
  },
  fourthCircleRadius: {
    radius: 260 * xScale,
    color: "#11A0DA",
    thick: 1,
  },
  thirdCircleRadius: {
    radius: 195 * xScale,
    color: "rgba(17, 160, 218, 0.3)",
    thick: 1,
  },
  secondCircleRadius: {
    radius: 125 * xScale,
    color: "rgba(17, 160, 218, 0.3)",
    thick: 1,
  },
  firstCircleRadius: {radius: 60 * xScale, color: "#11A0DA", thick: 1},
  logoRadius: {radius: 22 * xScale, color: "#11A0DA", thick: 1},
};

export const sizeCircleRadiusWeaksignal: ISizeCircleRadiusWS = {
  thirdCircleRadius: {radius: 260 * xScale, color: "#11A0DA", thick: 1},
  secondCircleRadius: {
    radius: 150 * xScale,
    color: "rgba(17, 160, 218, 0.3)",
    thick: 1,
  },
  firstCircleRadius: {radius: 60 * xScale, color: "#11A0DA", thick: 1},
};

export enum EXScale {
  coordConceptStart = 200 * xScale,
  coordConceptEnd = 255 * xScale,

  coordPrototypeStart = 130 * xScale,
  coordPrototypeEnd = 190 * xScale,

  coordProductStart = 64 * xScale,
  coordProductEnd = 120 * xScale,

  coordOtherStart = 250 * xScale,
  coordOtherEnd = 300 * xScale,

  coordFintechStart = 64 * xScale,
  coordFintechEnd = 255 * xScale,

  coordWeakSignalLowStart = 64 * xScale,
  coordWeakSignalLowEnd = 145 * xScale,

  coordWeakSignalHighStart = 155 * xScale,
  coordWeakSignalHighEnd = 255 * xScale,
}

export const subTechnologies = [
  {
    potential_volume: 3,
    trl: 3,
    name: "Биометрология, биоинформатика, прогнозное моделирование",
    critical: false,
    growth_potential: false,
    national: false,
    gpb: false,
    settings: 3,
  },
  {
    potential_volume: 2,
    trl: 3,
    name: "Системы поддержки принятия решений",
    critical: false,
    growth_potential: false,
    national: false,
    gpb: false,
    settings: 3,
  },
  {
    potential_volume: 1,
    trl: 3,
    name: "Телемедицина",
    critical: false,
    growth_potential: false,
    national: false,
    gpb: false,
    settings: 2,
  },
  {
    potential_volume: 1,
    trl: 2,
    name: "Предиктивная аналитика в медицине",
    critical: false,
    growth_potential: false,
    national: false,
    gpb: false,
    settings: 1,
  },
];
export const data = [
  {
    "Технологическое направление": "ИИ",
    "Название кластера": "Обработка естественного языка",
    Размер: 3,
    Зрелость: "высокая",
  },
  {
    "Технологическое направление": "ИИ",
    "Название кластера": "Компьютерное зрение",
    Размер: 4,
    Зрелость: "высокая",
  },
  {
    "Технологическое направление": "ИИ",
    "Название кластера": "Распознавание речи",
    Размер: 2,
    Зрелость: "средняя",
  },
  {
    "Технологическое направление": "ИИ",
    "Название кластера": "Генеративные модели",
    Размер: 3,
    Зрелость: "низкая",
  },
  {
    "Технологическое направление": "ИИ",
    "Название кластера": "Интеллектуальные помощники",
    Размер: 4,
    Зрелость: "высокая",
  },
  {
    "Технологическое направление": "ИИ",
    "Название кластера": "Роботизированное обучение",
    Размер: 2,
    Зрелость: "средняя",
  },
  {
    "Технологическое направление": "машинное обучение и Big Data",
    "Название кластера": "Анализ больших данных",
    Размер: 4,
    Зрелость: "средняя",
  },
  {
    "Технологическое направление": "машинное обучение и Big Data",
    "Название кластера": "Глубокое обучение",
    Размер: 5,
    Зрелость: "высокая",
  },
  {
    "Технологическое направление": "машинное обучение и Big Data",
    "Название кластера": "Распределенные вычисления",
    Размер: 3,
    Зрелость: "средняя",
  },
  {
    "Технологическое направление": "машинное обучение и Big Data",
    "Название кластера": "Предсказательное моделирование",
    Размер: 4,
    Зрелость: "высокая",
  },
  {
    "Технологическое направление": "машинное обучение и Big Data",
    "Название кластера": "Автоматизация данных",
    Размер: 2,
    Зрелость: "низкая",
  },
  {
    "Технологическое направление": "Многосоставные и кросс-функциональные",
    "Название кластера": "Облачные вычисления и микросервисы",
    Размер: 5,
    Зрелость: "высокая",
  },
  {
    "Технологическое направление": "Многосоставные и кросс-функциональные",
    "Название кластера": "Интернет вещей (IoT)",
    Размер: 3,
    Зрелость: "средняя",
  },
  {
    "Технологическое направление": "Многосоставные и кросс-функциональные",
    "Название кластера": "Квантовые вычисления",
    Размер: 1,
    Зрелость: "низкая",
  },
  {
    "Технологическое направление": "Многосоставные и кросс-функциональные",
    "Название кластера": "Кибербезопасность",
    Размер: 4,
    Зрелость: "высокая",
  },
  {
    "Технологическое направление": "Многосоставные и кросс-функциональные",
    "Название кластера": "Индустриальный интернет",
    Размер: 2,
    Зрелость: "средняя",
  },
  {
    "Технологическое направление": "Новые технологии сбережения здоровья",
    "Название кластера": "Персонализированная медицина",
    Размер: 2,
    Зрелость: "низкая",
  },
  {
    "Технологическое направление": "Новые технологии сбережения здоровья",
    "Название кластера": "Биосенсоры",
    Размер: 3,
    Зрелость: "средняя",
  },
  {
    "Технологическое направление": "Новые технологии сбережения здоровья",
    "Название кластера": "Теле-медицина",
    Размер: 4,
    Зрелость: "высокая",
  },
  {
    "Технологическое направление": "Новые технологии сбережения здоровья",
    "Название кластера": "Виртуальные помощники для пациентов",
    Размер: 2,
    Зрелость: "средняя",
  },
  {
    "Технологическое направление": "Новые технологии сбережения здоровья",
    "Название кластера": "Генная терапия",
    Размер: 3,
    Зрелость: "низкая",
  },
  {
    "Технологическое направление": "Аэрокосмические технологии",
    "Название кластера": "Гиперзвуковые летательные аппараты",
    Размер: 3,
    Зрелость: "низкая",
  },
  {
    "Технологическое направление": "Аэрокосмические технологии",
    "Название кластера": "Спутниковая связь",
    Размер: 4,
    Зрелость: "высокая",
  },
  {
    "Технологическое направление": "Аэрокосмические технологии",
    "Название кластера": "Микроспутники",
    Размер: 2,
    Зрелость: "средняя",
  },
  {
    "Технологическое направление": "Аэрокосмические технологии",
    "Название кластера": "Суборбитальные полеты",
    Размер: 3,
    Зрелость: "низкая",
  },
  {
    "Технологическое направление": "Аэрокосмические технологии",
    "Название кластера": "Управляемые полеты дронов",
    Размер: 5,
    Зрелость: "высокая",
  },
  {
    "Технологическое направление": "Новые материалы",
    "Название кластера": "Нанокомпозиты",
    Размер: 4,
    Зрелость: "средняя",
  },
  {
    "Технологическое направление": "Новые материалы",
    "Название кластера": "Сверхпроводящие материалы",
    Размер: 3,
    Зрелость: "низкая",
  },
  {
    "Технологическое направление": "Новые материалы",
    "Название кластера": "Графеновые технологии",
    Размер: 2,
    Зрелость: "низкая",
  },
  {
    "Технологическое направление": "Новые материалы",
    "Название кластера": "Умные покрытия",
    Размер: 4,
    Зрелость: "средняя",
  },
  {
    "Технологическое направление": "Новые материалы",
    "Название кластера": "Легкие сплавы для авиации",
    Размер: 5,
    Зрелость: "высокая",
  },
  {
    "Технологическое направление": "Микроэлектроника",
    "Название кластера": "3D печать электронных компонентов",
    Размер: 3,
    Зрелость: "средняя",
  },
  {
    "Технологическое направление": "Микроэлектроника",
    "Название кластера": "Наноэлектроника",
    Размер: 2,
    Зрелость: "низкая",
  },
  {
    "Технологическое направление": "Микроэлектроника",
    "Название кластера": "Гибкие дисплеи",
    Размер: 4,
    Зрелость: "высокая",
  },
  {
    "Технологическое направление": "Микроэлектроника",
    "Название кластера": "Оптические чипы",
    Размер: 3,
    Зрелость: "средняя",
  },
  {
    "Технологическое направление": "Микроэлектроника",
    "Название кластера": "Мемристоры",
    Размер: 1,
    Зрелость: "низкая",
  },
  {
    "Технологическое направление": "Современное производство и робототехника",
    "Название кластера": "Кооперативные роботы",
    Размер: 5,
    Зрелость: "высокая",
  },
  {
    "Технологическое направление": "Современное производство и робототехника",
    "Название кластера": "3D печать металлов",
    Размер: 3,
    Зрелость: "средняя",
  },
  {
    "Технологическое направление": "Современное производство и робототехника",
    "Название кластера": "Интеллектуальные сборочные линии",
    Размер: 4,
    Зрелость: "высокая",
  },
  {
    "Технологическое направление": "Современное производство и робототехника",
    "Название кластера": "Автоматизированные склады",
    Размер: 2,
    Зрелость: "средняя",
  },
  {
    "Технологическое направление": "Современное производство и робототехника",
    "Название кластера": "Роботы для обслуживания",
    Размер: 3,
    Зрелость: "низкая",
  },
  {
    "Технологическое направление": "Современное производство и робототехника",
    "Название кластера": "Контроль качества с ИИ",
    Размер: 4,
    Зрелость: "высокая",
  },
  {
    "Технологическое направление": "Современное производство и робототехника",
    "Название кластера": "Дроны для мониторинга производства",
    Размер: 2,
    Зрелость: "средняя",
  },
  {
    "Технологическое направление": "Современное производство и робототехника",
    "Название кластера": "Умные сенсорные системы",
    Размер: 3,
    Зрелость: "низкая",
  },
];
